<template>
    <div>
        <div v-if="!isMobile" class="Commandes">
            <p class="SubTitle">{{ langPage['mobile-compte']['TXT_title_3'] }}</p>
            <div class="selectList">
                <div>
                    <el-select @change="initLoad" class="selectItem" v-model="value"
                               :placeholder="langPage['bov-commandes-liste']['TXT_vendeur']">
                        <el-option
                            v-for="item in commandes"
                            :key="item.id_commande"
                            :label="item.vendeur.nomBoutique"
                            :value="item.id_vendeur">
                        </el-option>
                    </el-select>
                    <el-select @change="initLoad" class="selectItem" v-model="years"
                               :placeholder="langPage['mobile-compte-commande-filtre']['TXT_annee']">
                        <el-option
                            v-for="(item,indexs) in yearList"
                            :key="indexs"
                            :label="item"
                            :value="item">
                        </el-option>
                    </el-select>
                    <el-select @change="initLoad" class="selectItem" v-model="months"
                               :placeholder="langPage['mobile-compte-commande-filtre']['TXT_mois']">
                        <el-option
                            v-for="item in monty"
                            :key="item"
                            :label="item"
                            :value="item<10?'0'+item:item">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="filter">
                <span @click="clear('Vendeur')" v-if="value">{{ langPage['bov-commandes-liste']['TXT_vendeur'] }}</span>
                <span @click="clear('Année')" v-if="years">Année</span>
                <span @click="clear('Mois')" v-if="months">{{
                        langPage['bov-commandes-transporteurs-ups']['TXT_mois']
                    }}</span>
                <span class="notbg" @click="clear('all')" v-if="value||years||months">Effacer les filtres</span>
            </div>
            <div class="flex">
                <div class="tab">
                    <p
                        :class="i==active?'active':''"
                        v-for="(item,i) in tabList"
                        :key="i"
                        @click="chooseTab(i)"
                    >{{ item }}</p>
                </div>
                <!-- <div>{{total}}</div> -->
            </div>
            <div v-if="active==0" v-loading="isLoading">
                <div @click="foldshow(1)">
                    <collapse :dataList="dataList"></collapse>
                </div>
            </div>
            <div v-if="active==1" class="goods">
                <goodsList :rows="3" :list="list" type="2"
                           @goDetail="goDetail"
                           @goCommande="goCommande"
                           :goodsListImgClass="'commandesGoodsListImgClass'">
                </goodsList>
            </div>
        </div>
        <div v-if="isMobile" class="mCommandes mobileCommon">
            <p class="SubTitle">{{ langPage['mobile-compte']['TXT_title_3'] }}</p>
            <div class="filterBtn" align="center" @click="is_show_filter=!is_show_filter">Filter</div>
            <div class="filter">
                <span @click="clear('Vendeur')" v-if="value">{{ langPage['bov-commandes-liste']['TXT_vendeur'] }}</span>
                <span @click="clear('Année')" v-if="years">{{
                        langPage['bov-commandes-transporteurs-ups']['TXT_annee']
                    }}</span>
                <span @click="clear('Mois')" v-if="months">{{
                        langPage['bov-commandes-transporteurs-ups']['TXT_mois']
                    }}</span>
                <span class="notbg" @click="clear('all')"
                      v-if="value||years||months">{{ langPage['v4-commandes']['TXT_effacerlesfiltres'] }}</span>
            </div>
            <div class="flex">
                <div class="tab">
                    <p
                        :class="i==active?'active':''"
                        v-for="(item,i) in tabList"
                        :key="i"
                        @click="chooseTab(i)"
                    >{{ item }}</p>
                </div>
                <!-- <div>{{total}}</div> -->
            </div>
            <div v-if="active==0">
                <div @click="foldshow(1)">
                    <collapse :dataList="dataList"></collapse>
                </div>
            </div>
            <div v-if="active==1">
                <div class="goods">
                    <goodsList :rows="1" :list="list" type="2" @goCommande="goCommande" @goDetail="goDetail">
                    </goodsList>
                </div>
            </div>

            <div>
                <!--过滤器filter的抽屉-->
                <el-drawer
                    :visible.sync="is_show_filter"
                    direction="ltr"
                    size="90%">
                    <div class="filter">
                        <div style=" position: sticky;top: 0;z-index: 4;">
                            <div class="selectList">
                                <div class="title">{{ langPage['v4-commandes']['TXT_filters'] }}</div>
                                <div>
                                    <el-select @change="initLoad" v-model="value"
                                               placeholder="">
                                        <el-option
                                            v-for="item in commandes"
                                            :key="item.id_commande"
                                            :label="item.vendeur.nomBoutique"
                                            :value="item.id_vendeur">
                                        </el-option>
                                    </el-select>
                                    <el-select @change="initLoad" v-model="years"
                                               :placeholder="langPage['bov-commandes-transporteurs-ups']['TXT_annee']">
                                        <el-option
                                            v-for="(item,indexs) in yearList"
                                            :key="indexs"
                                            :label="item"
                                            :value="item">
                                        </el-option>
                                    </el-select>
                                    <el-select @change="initLoad" v-model="months"
                                               :placeholder="langPage['bov-commandes-transporteurs-ups']['TXT_mois']">
                                        <el-option
                                            v-for="item in monty"
                                            :key="item"
                                            :label="item"
                                            :value="item<10?'0'+item:item">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-drawer>
            </div>
        </div>
    </div>
</template>
<script>
import goodsList from "../../components/goodsList";
import collapse from "../../components/collapse";

let commonUtils = require('@/utils/common_utils');

export default {
    name: "Commandes",
    components: {
        goodsList,
        collapse
    },
    computed: {
        langPage() {
            return this.$store.state['langPage']
        },
    },
    data() {
        return {
            isMobile: this.$store.state.isMobile,
            yearList: [],
            monty: [],
            commandes: [],
            dates: "",
            months: "",
            years: "",
            dataList: [],
            active: 0,
            tabList: ["Par commandes", "Par articles"],
            no: 0,
            activeName: "first",
            value: "",
            list: [],
            total: 0,
            is_show_filter: false,
            isLoading: false,
            isFirstLoadData: true,//是否是第一次获取数据
            // datas:[
            //   {meta:'name1',children:[{meta:'child1'}]},
            //   {meta:'name2'},
            //   {meta:'name3',children:[{meta:'child3'},{meta:'child31'}]},
            //   {meta:'name4',children:[{meta:'child4'}]},
            //   {meta:'name5'},
            // ],
            // ap:['name2','name3','child31','name5']
        };
    },
    created() {
        this.init();
        this.getCommandes()
        this.getvender()
        // this.getVal(this.datas, this.ap)
    },
    watch: {},
    methods: {
        getCommandes() {
            let commandesArr = [];
            let newArr = []
            this.$api.info.orderList({
                id_vendeur: "",
                id_acheteur: "",
                page: "",
                pageSize: "",
                date: "",
            }).then(res => {
                if (res.code != 0) {
                    if (this.isFirstLoadData) {
                        this.isFirstLoadData = false;
                        this.getCommandes();
                    }
                    return;
                }
                for (var i = 0; i < res.data.list.length; i++) {
                    commandesArr = commandesArr.concat(res.data.list[i].commandes)
                }
                for (let j = 0; j < commandesArr.length; j++) {
                    for (let k = j + 1; k < commandesArr.length; k++) {
                        if (
                            !commonUtils.isEmpty(commandesArr[j])
                            && !commonUtils.isEmpty(commandesArr[k])
                            && (commandesArr[j].vendeur.nomBoutique == commandesArr[k].vendeur.nomBoutique)) {
                            commandesArr.splice(k, 1)
                            j--
                        }
                    }
                }
                this.commandes = commandesArr;
                if (!commonUtils.isEmpty(this.commandes)) {
                    this.list = this.commandes[0].produits;
                }
                this.$forceUpdate();
            })
        },
        initLoad() {
            if (this.years && this.months || this.value) this.init()
        },
        init() {
            let para = {
                id_vendeur: this.value,
                id_acheteur: "",
                page: "",
                pageSize: "",
                date: this.years && this.months ? this.years + '-' + this.months : ""
            }
            this.isLoading = true;
            this.$api.info.orderList(para).then(res => {
                this.isLoading = false;
                this.total = res.data.page.total
                let data = res.data.list;
                this.dataList = data;
                let curArr = []
                let monty = []
                this.dataList.forEach((item, index) => {
                    for (var i = 0; i < item.commandes.length; i++) {
                        let year = item.commandes[i].dateCommande.split('-')[2]
                        let mon = item.commandes[i].dateCommande.split('-')[1]
                        let val = `${year}-${mon}`
                        monty.push(mon)
                        curArr[index] = year
                        break
                    }
                })
                let arrs = []
                for (var j = 0; j < monty.length; j++) {
                    if (monty.indexOf(monty[j]) == j) {
                        arrs.push(monty[j])
                    }
                }
                this.monty = arrs.sort((a, b) => {
                    return a - b
                })
                let arrsYear = []
                for (var k = 0; k < curArr.length; k++) {
                    if (curArr.indexOf(curArr[k]) == k) {
                        arrsYear.push(curArr[k])
                    }
                }
                this.yearList = arrsYear
            })
        },
        clear(str) {
            if (str == 'Vendeur')
                this.value = ''
            else if (str == 'Année')
                this.years = ''
            else if (str == 'Mois')
                this.months = ''
            else this.months = '', this.years = '', this.value = ''
            this.init()
        },
        getvender() {
            this.$api.info.getvender({
                id_vendeur: "",
                id_acheteur: "",
                page: "",
                pageSize: "",
                start_time: "2020-04-08",
                end_time: "2020-04-08"
            }).then(res => {
                console.log(res)
            })
        },
        change(e, i) {
            console.log(this.s);
        },
        closeTag(i) {
            this.selectval.splice(i, 1);
        },
        deletAll() {
            for (var i in this.selectval) {
                this.selectval.splice(i, 1, "");
            }
        },
        foldshow(i) {
            this.no = i;
        },
        chooseTab(i) {
            this.active = i;
        },
        goDetail(item) {
            let url = `/ProductDetail?id=${item.id_produit}&vendu_par=${item.vendu_par}&vid=${item.id_vendeur}&categorie_id=${item.id_categorie}`;
            window.open(url, '_blank');
        },
        goCommande() {
            let commande = this.commandes[0];
            let url = `/moncompte/crticles?commandeId=${commande.id_commande_groupe}&acheteurId=${this.$store.state.userInfo.id_acheteur}`;
            window.open(url, '_blank');
        }
    }
};
</script>

<style lang="less" scoped src="@/assets/viewCss/views/Moncompte/Commandes.less">
</style>
<style lang="less">

.commandesGoodsListImgClass {
    width: 220px;
    height: 336px;
}
</style>
<style lang="less">
.Commandes {
    .el-input {
        // width: 112px;
        // height: 0.48rem;
        font-size: 14px;
    }

    .el-input__inner {
        // width: 112px;

    }

    .el-date-editor .el-range-separator {
        line-height: .4rem;
    }
}

.mCommandes {
    .el-input {
        // width: 112px;
        // height: 0.48rem;
        font-size: 10pt;
    }

    .el-input__inner {
        // width: 112px;

    }

    .el-date-editor .el-range-separator {
        /*line-height: .4rem;*/
    }
}
</style>
